<template>
  <v-dialog persistent v-model="dialogCoupon" max-width="700px" scrollable>
    <v-card class="pa-6">
      <h3 class="mb-5">Cupom de Afiliado</h3>
      <fragment v-if="!hasCoupon">
        <v-alert class="mb-4" type="warning" elevation="2" icon="mdi-alert"
          >O cupom não poderá ser alterado após ser definido.</v-alert
        >
        <BaseTextField
          label="Cupom de Afiliado"
          type="text"
          class="textinput mb-5"
          placeholder="Insira seu cupom personalizado de afiliado"
          tabindex="1"
          v-model="coupon"
          :error-messages="couponError"
          @input="couponInput"
          maxlength="16"
          counter="16"
        ></BaseTextField>
      </fragment>
      <v-col class="justify-center" style="text-align: center">
        <h1 class="couponStyle">{{ couponRegistred }}</h1></v-col
      >

      <v-btn
        color="tertiary"
        style="color: white"
        class="mb-2"
        @click="copyCoupon"
        >{{ buttonText }}
      </v-btn>
      <v-btn @click="changeDialogCoupon(null)">Cancelar</v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BaseTextField from "@/components/forms/BaseTextField.vue";
export default {
  name: "DialogCoupon",
  components: {
    BaseTextField,
  },
  data() {
    return {
      coupon: "",
      couponError: "",
    };
  },
  computed: {
    ...mapGetters(["infoDialogCoupon", "dialogCoupon", "userInfo"]),
    hasCoupon() {
      return this.infoDialogCoupon?.cupom !== "";
    },
    buttonText() {
      return !this.hasCoupon ? "Salvar" : "Copiar Cupom";
    },
    couponRegistred: {
      get() {
        return this.infoDialogCoupon?.cupom;
      },
      set(value) {
        this.coupon = value;
      },
    },
  },
  methods: {
    ...mapActions(["changeDialogCoupon", "postCoupon", "showSnackbarSuccess"]),
    couponInput() {
      this.couponError = "";
      this.coupon = this.coupon.toUpperCase().replace(/[^A-Z0-9-\s]/g, "");
      this.coupon = this.coupon.replace(/\s/g, "-");
      if (this.coupon.length > 16) {
        this.couponError = "O cupom deve ter no máximo 16 caracteres.";
      } else if (this.coupon.length < 3) {
        this.couponError = "O cupom deve ter no mínimo 3 caracteres.";
      }
    },
    copyCoupon() {
      if (!this.hasCoupon) {
        this.postCoupon({
          idprograma: this.infoDialogCoupon.idprograma,
          idafiliado: this.userInfo.idafiliado,
          cupom: this.coupon,
        });
      } else {
        this.copyToClipboard(this.infoDialogCoupon.cupom);
      }
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.showSnackbarSuccess("Cupom copiado com sucesso!");
        })
        .catch(err => {
          console.error("Erro ao copiar cupom:", err);
        });
    },
  },
  watch: {
    dialogCoupon() {
      if (!this.dialogCoupon) {
        this.coupon = "";
        this.couponError = "";
      }
    },
  },
  destroyed() {
    this.coupon = "";
    this.couponError = "";
  },
};
</script>
<style scoped>
.couponStyle {
  font-size: 2rem;
  font-weight: 700;
}
</style>
